export const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || 'https://api.nextdns.io';

export const API_BASE_URL_IPV4 = process.env.REACT_APP_API_ENDPOINT || 'https://ipv4.api.nextdns.io';

export const STRIPE_PUBLISHABLE_KEY =
  process.env.NODE_ENV === 'development'
    ? 'pk_test_xHbIDdF5ADZztKNkMhX16z8t00GyDFxpyl'
    : 'pk_live_ZiQCKab5KPVOOOGWYUojPbY600g6BW6kIH';
